import { hasImageInput, clampTo } from '../../tools';
import type { baiduModelConfig } from '../types';

export const googleConfigs: Record<string, baiduModelConfig> = {
    'nano-banana-2': {
        // https://tcnxnzs113h4.feishu.cn/wiki/N44nwUBvqilqVWkQkuwcodwOnb2?fromScene=spaceOverview
        apiPath: '/v3/aigc/image',
        pollApiPath: '/v3/tasks/{id}',
        statusMapping: {
            taskIdPath: 'taskId',
            createErrorPath: 'message',
            statePath: 'status',
            success: ['SUCCESS'],
            failed: ['FAILED'],
            processing: ['READY', 'RUNNING'],
            errorPath: 'videoGenerateTaskInfo.errMsg',
            imageUrlPath: 'videoGenerateTaskInfo.videoGenerateTaskOutput.mediaBasicInfos[0].source.sourceUrl',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            const enableWebSearch = typeof providerOptions?.enable_web_search === 'boolean' ? providerOptions.enable_web_search : undefined;
            const thinkingLevel = typeof providerOptions?.thinking_level === 'string' ? clampTo(providerOptions.thinking_level, ['MINIMAL', 'HIGH'] as const, 'MINIMAL') : undefined;
            return {
                model: "NB2",
                messages: [
                    {
                        role: "user",
                        content: [
                            {
                                type: "text",
                                text: prompt
                            },
                            ...(hasImage ? image_urls.slice(0, 14).map((imageUrl) => ({
                                type: "image_url",
                                image_item: {
                                    image_url: imageUrl
                                }
                            })) : [])
                        ]
                    }
                ],
                n: 1,
                size: clampTo(aspectRatio || '1:1', ['21x9', '16x9', '9x16', '8x1', '1x8', '5x4', '4x5', '4x1', '1x4', '4x3', '3x4', '3x2', '2x3', '1x1'] as const, '1:1'),
                quality: clampTo(image_resolution || '1K', ['0.5K', '1K', '2K', '4K'] as const, '1K'),
                ...(enableWebSearch ? {
                    tools: [
                        {
                            type: "function",
                            function: {
                                name: "GWebSearch",
                                description: "网页搜索"
                            }
                        }
                    ],
                } : {}),
                ...(thinkingLevel ? {
                    extra_body: {
                        g_model: {
                            thinking_config: {
                                thinking_level: thinkingLevel
                            }
                        }
                    }
                } : {})
            }
        },
    },
    'nano-banana-pro': {
        // https://tcnxnzs113h4.feishu.cn/wiki/N44nwUBvqilqVWkQkuwcodwOnb2?fromScene=spaceOverview
        apiPath: '/v3/aigc/image',
        pollApiPath: '/v3/tasks/{id}',
        statusMapping: {
            taskIdPath: 'taskId',
            createErrorPath: 'message',
            statePath: 'status',
            success: ['SUCCESS'],
            failed: ['FAILED'],
            processing: ['RUNNING'],
            errorPath: '',
            imageUrlPath: 'videoGenerateTaskInfo.videoGenerateTaskOutput.mediaBasicInfos[0].source.sourceUrl',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            return {
                model: "NBP",
                messages: [
                    {
                        role: "user",
                        content: [
                            {
                                type: "text",
                                text: prompt
                            },
                            ...(hasImage ? image_urls.slice(0, 14).map((imageUrl) => ({
                                type: "image_url",
                                image_item: {
                                    image_url: imageUrl
                                }
                            })) : [])
                        ]
                    }
                ],
                n: 1,
                size: clampTo(aspectRatio || '1:1', ['21:9', '16:9', '3:2', '4:3', '5:4', '1:1', '4:5', '3:4', '2:3', '9:16'] as const, '1:1'),
                quality: clampTo(image_resolution || '1K', ['1K', '2K', '4K'] as const, '1K'),
            }
        },
    },
    'nano-banana': {
        // https://tcnxnzs113h4.feishu.cn/wiki/N44nwUBvqilqVWkQkuwcodwOnb2?fromScene=spaceOverview
        apiPath: '/v3/aigc/image',
        pollApiPath: '/v3/tasks/{id}',
        statusMapping: {
            taskIdPath: 'taskId',
            createErrorPath: 'message',
            statePath: 'status',
            success: ['SUCCESS'],
            failed: ['FAILED'],
            processing: ['RUNNING'],
            errorPath: '',
            imageUrlPath: 'videoGenerateTaskInfo.videoGenerateTaskOutput.mediaBasicInfos[0].source.sourceUrl',
        },
        enableTranslation: false,
        buildInput: (params) => {
            // 图像参数
            const { prompt, image_urls, aspectRatio, image_resolution, providerOptions } = params;
            // 是否有图像
            const hasImage = hasImageInput(image_urls);
            // 图像生成
            return {
                model: "NB",
                messages: [
                    {
                        role: "user",
                        content: [
                            {
                                type: "text",
                                text: prompt
                            },
                            ...(hasImage ? image_urls.slice(0, 3).map((imageUrl) => ({
                                type: "image_url",
                                image_item: {
                                    image_url: imageUrl
                                }
                            })) : [])
                        ]
                    }
                ],
                n: 1,
                size: clampTo(aspectRatio || '1:1', ['21:9', '16:9', '3:2', '4:3', '5:4', '1:1', '4:5', '3:4', '2:3', '9:16'] as const, '1:1'),
                quality: '1K',
            }
        },
    },
};